export class ItemInfoWarnings {
  StockInfo_BlockedInterfaceKinds: string[];
  StockInfo_NoCredentials: boolean;
  AdditionalWarnings: string[];

  static anyWarnings(warnings: ItemInfoWarnings): boolean {
    if (warnings?.StockInfo_NoCredentials || warnings?.StockInfo_BlockedInterfaceKinds?.length || warnings?.AdditionalWarnings?.length) {
      return true;
    }
    return false;
  }
}